import * as React from 'react'
import { useState } from 'react'
import { get } from 'lodash'
import { OnboardingComponentProps } from '.'
import { useLoadVGSForm } from '../../../hooks/useVGS'
import Button from '@doordash/component-button'
import { useValidation } from '../../organisms/workflow-template/useValidation'
import { ssnFieldProps } from './styles'

export const VGSFormComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({
    templateResponseData,
    apiPath,
    label,
    data,
    onChange,
    onSubmitStep,
  }: OnboardingComponentProps) => {
    const [form] = useLoadVGSForm(data, ssnFieldProps)
    const [isLoading, setIsLoading] = useState(false)
    const { validateData } = useValidation()
    return (
      <Button
        state={isLoading ? Button.States.Loading : Button.States.Default}
        onClick={() => {
          const jsonData = get(templateResponseData, apiPath)
          const isSSNValid =
            form.state.ssn.isValid && form.state.ssnConfirm.isValid
          if (validateData(templateResponseData) && isSSNValid) {
            setIsLoading(true)
            onSubmitStep(templateResponseData, { form })
            return
          }

          onChange({ ...jsonData, form })
        }}
      >
        {label}
      </Button>
    )
  }
)
